import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import ProdutoForm from '../components/ProdutoForm';
import ItemFotoProduto from '../components/ItemFotoProduto';
import numeral from "numeral";
import { getTemPermissao } from "../utils/LoginManager";
import { resolveImageUrl } from '../utils/Storage';
import CadastroRegistro from '../tutoriais/CadProdutos';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    buscaOrdem: { campo: 'prod_descricao', ordem: 'ASC' },
  };

  componentDidMount() {
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { busca, pagina, limite, buscaOrdem } = this.state;
    axios
      .get('/produtos', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          nome: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({ salvando: true })

    let request;
    if (registro.prod_idf) {
      request = axios.put(`/produtos/update/${registro.prod_idf}`, registro);
    } else {
      request = axios.post(`/produtos/store`, registro)
    }

    request
      .then(response => {
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        this.getListaRegistros();
        message.success('Produto gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })

        if (error.response.status === 500) {
          Modal.error({ title: 'Falha - Atenção!', content: 'NCM Incorreto. ' + error.response.data.mensagem, okText: 'OK', })
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }
      })
  }


  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/produtos/show/${registro.prod_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.prod_grupo = {
          key: data.dados.prod_grupo ? String(data.dados.prod_grupo) : '0',
          label: data.dados.grp_descricao ? data.dados.grp_descricao : '',
        }
        data.dados.prod_marca = {
          key: data.dados.prod_marca ? String(data.dados.prod_marca) : '0',
          label: data.dados.mar_descricao ? data.dados.mar_descricao : '',
        }
        data.dados.prod_medida = {
          key: data.dados.prod_medida ? String(data.dados.prod_medida) : '0',
          label: data.dados.med_descricao ? data.dados.med_descricao : '',
        }

        data.dados.prod_ncm =
          data.dados.prod_ncm != null && String(data.dados.prod_ncm).trim() !== ''
            ? String(data.dados.prod_ncm).padStart(8, '0')
            : '';

        // data.dados.pathImagem = data.dados.prod_imagem ? resolveImageUrl(`emp${data.dados.prod_empresa}/produtos/${data.dados.prod_idf}.${data.dados.prod_imagem}`) : '';
        data.dados.pathImagem = '';
        // if (process.env.NODE_ENV === 'development') {
        //   data.dados.pathImagem = data.dados.prod_imagem ? resolveImageUrl(`emp${data.dados.prod_empresa}/produtos/${data.dados.prod_idf}.${data.dados.prod_imagem}`) : '';
        // } else {
        //   data.dados.pathImagem = data.dados.prod_imagem ? resolveImageUrl(`emp${data.dados.prod_empresa}/produtos/${data.dados.prod_idf}.${data.dados.prod_imagem}`) : '';
        // }

        data.dados.pathImagem = data.dados.prod_imagem ? resolveImageUrl(`emp${data.dados.prod_empresa}/produtos/${data.dados.prod_imagem}`) : '';

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            data,
            visualizar,
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/produtos/delete/${registro.prod_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.prod_idf === registro.prod_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            if (error.request.status === 412) {
              Modal.info({ title: 'Atenção', content: error.request.response, okText: 'OK', })
            }
          })
      }
    })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        data: {
          listaGrade: [],
          dados: {
            prod_idf: 0,
            prod_grade: 0,
            prod_controla_estoque: 1,
            prod_flag_catalogo: 0,
            prod_grupo: { key: '0' },
            prod_marca: { key: '0' },
            prod_medida: { key: '0' },
          }
        },
        visualizar: false,
        imgNome: '',
        imgSize: '0',
        imgData: '',
        base64: '',
        pathImagem: "",
      }
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }


  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/produtos/ativa/${registro.prod_idf}/1`)
    } else {
      request = axios.put(`/produtos/ativa/${registro.prod_idf}/0`)
    }

    request.then(response => {
      registro.prod_situacao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };



  renderAtiva = (prod_situacao, registro) => {
    return (
      <Switch
        checkedChildren="Ativo"
        unCheckedChildren="Inativo"
        checked={prod_situacao ? true : false}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
        disabled={getTemPermissao('ProdutosPage', 'editar') ? false : true}
      />
    );
  };

  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('ProdutosPage', 'editar') ? (
          <Tooltip title="Editar">
            <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('ProdutosPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : null}
      </ButtonGroup>
    );
  };

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = this.state.buscaOrdem.campo && this.state.buscaOrdem.campo === column.dataIndex ? (this.state.buscaOrdem.ordem && this.state.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    this.state['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite } = this.state;

    return (
      <div className="contentRoutesContainer">

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Cadastro de Produtos</span>
          <Tooltip title="Ajuda">
            <Button
              type="primary"
              onClick={() => this.setState({ modalOpen: true })}
              icon="question"
              className="botao-ajuda"
            ></Button>
          </Tooltip>
        </div>

        <div className="divider-page1" />

        <div className="pageFiltro">
          {getTemPermissao('ProdutosPage', 'novo') ? (
            <Button
              type="primary"
              onClick={this.onAdicionarClick}
              className="botao-primary"
            >
              Adicionar
            </Button>
          ) : null}

          <Search
            placeholder="Pesquisar..."
            onSearch={this.onBuscar}
            enterButton
            className="pageFiltro-busca"
          />

          <ProdutoForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          <CadastroRegistro
            isOpen={this.state.modalOpen}
            onClose={() => this.setState({ modalOpen: false })}
          />
        </div>

        <br />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={listaRegistros}
          rowKey={(registro => registro.prod_idf)}
        >
          <Column
            key="foto_produto"
            title="Foto"
            width={70}
            align="center"
            className="listaCadastro"
            render={(text, registro) => (
              <ItemFotoProduto
                produtoId={registro.prod_idf}
                prodImagem={registro.prod_imagem}
                prodEmpresa={registro.prod_empresa}
                tamanho={44}
                alt={registro.prod_descricao}
              />
            )}
          />
          <Column
            key="prod_codigo"
            dataIndex="prod_codigo"
            title={this.renderTitulo("Código")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={40}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="prod_descricao"
            dataIndex="prod_descricao"
            title={this.renderTitulo("Descrição")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={150}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="mar_descricao"
            dataIndex="mar_descricao"
            title={this.renderTitulo("Marca")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="grp_descricao"
            dataIndex="grp_descricao"
            title={this.renderTitulo("Grupo")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="prod_ncm"
            dataIndex="prod_ncm"
            title={this.renderTitulo("NCM")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="pest_qtde"
            dataIndex="pest_qtde"
            title={this.renderTitulo("Estoque")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="right"
            className="listaCadastro"
            render={this.renderValor}
          />
          <Column
            key="prod_vlr_venda"
            dataIndex="prod_vlr_venda"
            title={this.renderTitulo("Vlr Venda")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="right"
            className="listaCadastro"
            render={this.renderValor}
          />
          <Column
            key="prod_situacao"
            dataIndex="prod_situacao"
            title={this.renderTitulo("Situação")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderAtiva}
            width={70}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="acoes"
            title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
            render={this.renderAcoes}
            width={70}
            align="center"
            className="listaCadastro"
          />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProdutosPage.js